import { Routes } from '@angular/router';
import { PAGE } from './routes';
import { GameId } from './common/model/game-id';

export const routes: Routes = [
  {
    path: `${PAGE.LAUNCH_GAME}/:gameId`,
    loadComponent: () =>
      import('./features/game-iframe/game-iframe.page').then((m) => m.GameIframePage),
  },
  { path: '**', redirectTo: `${PAGE.LAUNCH_GAME}/${GameId.Solitaire}` },
];
